(()=>{

  if(!customElements.get('scroll-back-to-top')) {

    class ScrollBackToTop extends HTMLElement {

      constructor() {
        super();
        this.trigger = this.querySelector('[data-trigger]');
        this.init();
      }

      /**
       * init
       */
      init() {

        // Scroll back to top when the button is clicked
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // Show trigger based on scroll position
        document.addEventListener('scroll', (event) => {
          if(window.scrollY <= window.innerHeight) {
            this.trigger.classList.remove('active');
          } else {
            this.trigger.classList.add('active');
          }
        })


      }

    }

    window.ScrollBackToTop = ScrollBackToTop;
    customElements.define('scroll-back-to-top', ScrollBackToTop);

  }

})();
